import React from "react";
import EmailTemplateDetailsContainer from "../../../modules/OrganizationEmailTemplates/containers/EmailTemplateDetailsContainer/EmailTemplateDetailsContainer";
import { EMAIL_TEMPLATE_SCOPE_GEN } from "../../../modules/OrganizationEmailTemplates/hooks/EmailTemplatesHooks";

// General Admin: create / view / edit a standard email template.
// Reuses the org details container in "gen" scope.
const GAEmailTemplateDetails = () => {
  return <EmailTemplateDetailsContainer scope={EMAIL_TEMPLATE_SCOPE_GEN} />;
};

export default GAEmailTemplateDetails;
